module.exports = {"pathContext":{"name":"DiagnosticEdge","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"cursor","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"node","type":{"kind":"OBJECT","name":"Diagnostic","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/object-diagnostic-edge.json
// module id = 1761
// module chunks = 105124497002074